import {
  EMBED_CODE_CHECK_BEGIN,
  EMBED_CODE_CHECK_SUCCESS,
  EMBED_CODE_CHECK_FAILURE,
  EMBED_CODE_CHECK_CLEAR,
} from './../_types'
import campaignAPI from '@api/campaign'

const getDefaultState = () => {
  return {
    embedCodeCampaigns: [],
    embedCodeCheckCompleted: false,
    embedCodeCheckError: false,
    embedCodeCheckLoading: false,
  }
}
export const state = getDefaultState()

export const mutations = {
  [EMBED_CODE_CHECK_BEGIN](state) {
    state.embedCodeCheckCompleted = false
    state.embedCodeCheckLoading = true
    state.embedCodeCheckError = false
  },
  [EMBED_CODE_CHECK_SUCCESS](state, response) {
    state.embedCodeCheckCompleted = true
    state.embedCodeCheckLoading = false
    state.embedCodeCampaigns = response
  },
  [EMBED_CODE_CHECK_FAILURE](state) {
    state.embedCodeCheckError = true
    state.embedCodeCheckLoading = false
    state.embedCodeCheckCompleted = true
  },
  [EMBED_CODE_CHECK_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  checkEmbedCodePresence({ commit }) {
    commit(EMBED_CODE_CHECK_BEGIN)

    return campaignAPI.checkEmbedCodePresence()
    .then((response) => {
      commit(EMBED_CODE_CHECK_SUCCESS, response.data)
    }).catch(() => commit(EMBED_CODE_CHECK_FAILURE))
  },
  clearEmbedCodeState({ commit }) {
    commit(EMBED_CODE_CHECK_CLEAR)
  },
}
